import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import config from '../../Common/Configurations/APIConfig';
import apiService from "../../Common/Configurations/APIService";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useReactToPrint } from 'react-to-print';
const HotelVoucher = () => {
    const params = useParams();
    const navigate = useNavigate();
    const contentRef = useRef();
    const [pageLoading, setPageLoading] = useState(false);
    const [hotelBooking, setHotelBooking] = useState('');
    const [hotel, setHotel] = useState({});
    const [rooms, setRooms] = useState([]);
    const [guests, setGuests] = useState([]);
    const handlePrint = useReactToPrint({
        content: () => contentRef.current,
    });
    const handlePDF = () => {
        const input = contentRef.current;
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            const imgWidth = 210;
            const pageHeight = 297;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            pdf.save(hotelBooking.travellerName + '_booking_voucher.pdf');
        });
    };
    const GetData = () => {
        setPageLoading(true);
        apiService.getAll(config.GETHOTELBOOKINGDETAILS + "/" + params.hotelBookingId)
            .then((res) => {
                console.log(res);
                setHotelBooking(res.data);
                setHotel(res.data.hotelDetails)
                setRooms(res.data.hotelRoomDetails.requestedHotels);
                setGuests(res.data.hotelGuestInfos);
                setPageLoading(false);
            })
            .catch((err) => console.error("Error fetching company data", err));
    }
    useEffect(() => {
        GetData();
    }, []);
    return (
        <div className="container-fluid mt-2">
            <div className="col-xl-12">
                <div className="d-flex justify-content-end align-items-center mb-4">
                    <Link to="/my-hotelbookings" className="btn btn-outline-secondary">
                        <i className="ri-arrow-left-line me-2"></i>Back to Bookings
                    </Link>

                </div>

                <div className="card">

                    <div className="card-body">
                        {pageLoading === true ?
                            <div className="row align-items-center justify-content-center">
                                <div className="col-lg-12">
                                    <img src="/assets/images/loader.webp" width={"64px"} height={"64px"}></img>
                                    Loading, Please wait...
                                </div>
                            </div> :
                            <div className="row align-items-center justify-content-center">
                                <div className="col-lg-12">
                                    <div className="bg-white shadow-md rounded p-3 p-sm-4 confirm-details">
                                        <div className='row'>

                                            <div className='col-8'>
                                                <h4 className="text-6 mb-3 mb-sm-4">Hotel Booking Details</h4>
                                            </div>
                                            <div className='col-4'>
                                                <div className="btn-group btn-group-sm float-right d-print-none">
                                                    <Link className="btn btn-info border text-white shadow-none me-2 mr-2" onClick={handlePrint}>
                                                        <i className="ri-printer-line"></i> Print
                                                    </Link>
                                                    <Link className="btn btn-primary border text-white shadow-none me-2" onClick={handlePDF}>
                                                        <i className="ri-file-download-line"></i> Download Voucher
                                                    </Link>
                                                    <Link to={"/hotel/invoice/" + params.hotelBookingId} className="btn btn-secondary border text-white shadow-none me-2">
                                                        <i className="ri-file-download-line"></i> View Invoice
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div ref={contentRef}>
                                        <div className="card" style={{ textAlign: "start" }}>
                                            <div className="card-body">
                                                <div className="row mb-3">
                                                    <div className="col-lg-3">
                                                        <label><b>Booking No</b> : {hotelBooking.bookingNo}</label>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label><b>Destination</b> : {hotelBooking.city},{hotelBooking.country}</label>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label><b>Check-In </b> : {moment(hotelBooking.checkIn).format('Do MMM yyyy')}</label>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label><b>Check-Out </b> : {moment(hotelBooking.checkOut).format('Do MMM yyyy')}</label>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-lg-3">
                                                        <label><b>Hotel</b> : {hotel.hotelName}</label>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label><b>Address</b> : {hotel.address},{hotel.cityName},{hotel.countryName}</label>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label><b>Phone Number</b> : {hotelBooking.phoneNumber}</label>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-lg-3">
                                                        <label><b>Booking Status</b> : {hotelBooking.bookingStatus == "FAILED" ? <span className="badge bg-danger">FAILED</span> : hotelBooking.bookingStatus == "PENDING" ? <span className="badge bg-danger">PENDING</span> : <span className="badge bg-success">CONFIRMED</span>}</label>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label><b>Payment Status</b> : {hotelBooking.paymentStatus == "PENDING" ? <span className="badge bg-danger">PENDING</span> : <span className="badge bg-success">SUCCESS</span>}</label>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label><b>Guests</b> : {hotelBooking.noOfGuests}</label>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label><b>Rooms</b> : {hotelBooking.noOfRooms}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="card-header">
                                                <h5>Rooms</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="table-responsive table-card">
                                                    <table className="table align-middle" id="customerTable">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th></th>
                                                                <th>Room Type</th>
                                                                <th>Guests</th>
                                                                <th>Meal Type</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="list form-check-all">
                                                            {rooms.length > 0 && rooms.map((v, index) =>
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td className="id">{v.roomType}</td>
                                                                    <td className="id">Adults : {v.adults}, Kids: {v.kids}</td>
                                                                    <td className="id">{v.mealType}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="card-header">
                                                <h5>Guests</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="table-responsive table-card">
                                                    <table className="table align-middle" id="customerTable">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th className="text-center">Guest Names</th>
                                                                <th className="text-center">Type</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="list form-check-all">
                                                            {guests.length > 0 && guests.map((raa, index) =>
                                                                <React.Fragment key={index}>
                                                                    {raa.adultsFields.length > 0 && raa.adultsFields.map((ra, adultIndex) => (
                                                                        <tr key={adultIndex}>
                                                                            <td className="col-sm-3 text-center">{ra.title}. {ra.firstName} {ra.lastName}</td>
                                                                            <td className="col-sm-3 text-center">{ra.travelerType}</td>
                                                                        </tr>
                                                                    ))}
                                                                    {raa.kidsFields.length > 0 && raa.kidsFields.map((ra, adultIndex) => (
                                                                        <tr key={adultIndex}>
                                                                            <td className="col-sm-3 text-center">{ra.title}. {ra.firstName} {ra.lastName}</td>
                                                                            <td className="col-sm-3 text-center">{ra.travelerType}</td>
                                                                        </tr>
                                                                    ))}
                                                                </React.Fragment>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HotelVoucher;
